// Dans CatalogDashboard (au-dessus du <CartAside />)

import { useCustomerBalanceQuery, useCustomerQuery } from '@/hooks/useCustomers'
import { useStore } from '@/store/Store'
import CustomerSelect from './CustomerSelect'
import { formatCFA } from '@/lib/utils'

function CustomerBar() {
  const { state, dispatch } = useStore()
  const selectedId = state.cart.customerId
  const { data } = useCustomerQuery(selectedId ?? undefined, !!selectedId)
  const { data: bal } = useCustomerBalanceQuery(
    selectedId ?? undefined,
    !!selectedId && !data?.isWalkIn
  )

  const balance = bal?.balance ?? 0
  const isWalkIn = data?.isWalkIn ?? false

  return (
    <div className='flex flex-col items-start gap-2'>
      <CustomerSelect
        value={selectedId}
        onChange={(id) =>
          dispatch({ type: 'CART_SET_META', payload: { customerId: id } })
        }
        placeholder='Choisir un client (ou créer)'
      />
      {selectedId && data && !isWalkIn ? (
        <span className='text-sm text-muted-foreground '>
          Solde: <b>{formatCFA(balance)}</b>
        </span>
      ) : null}
    </div>
  )
}

export default CustomerBar
